import {
    PUSH_SEARCH_LIST,
    CLEAR_SEARCH_LIST,
    UPDATE_SEARCH_LIST
} from "@/store/mutations.type"

const StateKey = 'searchList'

export default {
    [CLEAR_SEARCH_LIST](state) {
        state[StateKey] = []
        state[`${StateKey}Offset`] = 0
        state[`${StateKey}FetchCompleted`] = false
    },

    [PUSH_SEARCH_LIST](state, items) {
        if (items.length) {
            items.forEach((item) => {
                if (item) state[StateKey].push(item)
            })
        }
        if (items.length === state[`${StateKey}Limit`]) {
            state[`${StateKey}Offset`] += state[`${StateKey}Limit`]
        } else {
            state[`${StateKey}FetchCompleted`] = true
        }
    },

    [UPDATE_SEARCH_LIST](state, payload) {
        const item = state[StateKey].find(item => item.id === payload.itemId)
        if(item) Object.assign(item, payload.value)
    }
}